import { CurrencyPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_CHIPLIST } from '@progress/kendo-angular-buttons';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_LISTVIEW } from '@progress/kendo-angular-listview';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { AgreementDetailedDto, AgreementsClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';

@Component({
  selector: 'unity-grid-agreement-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    KENDO_LISTVIEW,
    KENDO_CHIPLIST,
    GridSharedComponent,
    DateTimezonePipe,
    CurrencyPipe,
    ChipWorkflowStateSharedComponent,
    LinkGridcellSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-agreement-shared.component.html',
  styleUrl: './grid-agreement-shared.component.scss',
})
export class GridAgreementSharedComponent extends AbstractGridComponent<AgreementDetailedDto> {
  private readonly agreementsClient = inject(AgreementsClient);

  public readonly $userId = input.required<number>({ alias: 'userId' });

  protected readonly resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const userId = this.$userId();
      return query && userId ? { query, userId } : undefined;
    },
    stream: ({ params: { userId, query } }) =>
      this.agreementsClient.getAllForUserAsDetailed(userId, query.page, query.pageSize, query.orderBy, query.filter),
  });
}
